import React from 'react'

import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import { useLocation, useNavigate } from 'react-router-dom'
import { CasoGeneralComponent } from 'defcol-caso-general'
import FormPrincipal from './form-principal'


const RecepcionCobroCiaTercero = () => {
    const { state } = useLocation()
    const idCasoLocation = state?.row?.IdCaso ? state.row.IdCaso : 34;
    const idImplicado = state?.row?.IdImplicado ? state.row.IdImplicado : 1;
    const idOrganizacionCaso = state?.row?.idOrganizacionCaso ? state.row.idOrganizacionCaso : 8600399880;

    return (
        <Container>
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h6' className="text-center" style={{ backgroundColor: "#4F517A", color: "white" }} >
                        Recepcionar Cobro CIA Tercero - Caso {idCasoLocation}
                    </Card.Header>
                    <Card.Body>
                        <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} />
                    </Card.Body>
                </Card>

                <FormPrincipal idCaso={idCasoLocation} idOrgCaso={idOrganizacionCaso}/>
            </Container>
        </Container>
    )
}
export default RecepcionCobroCiaTercero